import _ from 'lodash';
import EAInputBloc from '../../../../../../../components/common/EAInputBloc';
import i18next from 'i18next';
import EAAutoCompleteInput from '../../../../../../../components/inputs/EAAutoCompleteInput';
import CalculatorMultipleSelectInput from '../../../calculatorInputs/CalculatorMultipleSelectInput';
import CalculatorMultipleValueInput from '../../../calculatorInputs/CalculatorMultipleValueInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const SetValue = ({
  fieldName,
  showLabel,
  availableValueOptions,
  variantAutoComplete,
  readOnly = false
}) => {
  const { setError, clearErrors } = useFormContext();
  const placeholder = i18next.t(`calculator.dialog.create.placeholder.selectValues`);
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';

  if (!_.isEmpty(availableValueOptions)) {
    if (variantAutoComplete === true) {
      return (
        <EAInputBloc
          label={label}
          customLabelStyle={{ fontSize: '14px' }}
        >
          <EAAutoCompleteInput
            fieldName={fieldName}
            options={availableValueOptions}
            placeholder={i18next.t(
              `rules.configuration.criteria.fields.value.autocompletePlaceholder`
            )}
            isRequired
            multiple={true}
            triggerOnContinue
            disabled={readOnly}
          />
        </EAInputBloc>
      );
    }
    return (
      <CalculatorMultipleSelectInput
        fieldName={fieldName}
        isRequired
        label={label}
        placeholder={placeholder}
        options={availableValueOptions}
        uxVariant="criteriaInput"
        variant="standard"
        triggerOnContinue
        validate={(value) => {
          if (value.length === 0) {
            setError(fieldName, {
              type: 'manual',
              message: i18next.t(`calculator.errors.criterionValueEmpty`),
            });
            return false;
          } else {
            clearErrors(`${fieldName}`);
            return true;
          }
        }}
        disabled={readOnly}
      />
    );
  }
  return (
    <CalculatorMultipleValueInput
      fieldName={fieldName}
      isRequired
      label={label}
      placeholder={placeholder}
      uxVariant="criteriaInput"
      triggerOnContinue
      validate={(value) => {
        if (value.length === 0) {
          setError(fieldName, {
            type: 'manual',
            message: i18next.t(`calculator.errors.criterionValueEmpty`),
          });
          return false;
        } else {
          clearErrors(fieldName);
          return true;
        }
      }}
      disabled={readOnly}
    />
  );
};

export default SetValue;
